<template>
  <div :style='{ backgroundImage: `url(${image})` }' class='bg-cover h-full pb-10 bg-opacity-10'>
    <div class='max-w-6xl mx-auto p-4 lg:px-8 xl:px-0'>
      <div class='max-w-xl mx-auto mt-10 md:p-10 p-6 bg-white rounded-md'>
        <div class='flex justify-between'>
          <div class='flex justify-between items-center mb-3'>
            <div id='signin'>
            </div>

            <div id='register'>
              <router-link
                :to="localePath('/reset-password')"
                :class="
                  $route.path.search('/reset-password') > 0
                    ? 'text-green-700 border-b-2 border-green-700'
                    : 'text-gray-500 hover:text-green-700 hover:border-b-2 hover:border-green-700'
                "
                class='text-xl font-medium focus:outline-none'
              >
                {{ $t('reset_password') }}
              </router-link>
            </div>
          </div>
        </div>
        <ValidationObserver v-if='isPhoneSend' ref='observer' v-slot='{ passes, invalid }'>
          <form @submit.prevent='passes(onSubmitPhone)' class='space-y-3'>
            <div class='mt-2'>
              <ValidationProvider
                v-slot='{ valid, errors }'
                rules='required|phone'
                name='phone'
              >
                <input
                  name='phone'
                  type='text'
                  autocomplete='text'
                  v-model='rest.phone'
                  :placeholder="$t('phone')"
                  :state='errors[0] ? false : valid ? true : null'
                  required
                  class='
                    focus:outline-none
                    appearance-none
                    block
                    w-full
                    px-3
                    py-2
                    border border-gray-300
                    rounded-md
                    shadow-sm
                    placeholder-gray-400
                    sm:text-sm
                  '
                  :class="
                    errors.length > 0
                      ? 'border-red-400'
                      : rest.phone
                      ? 'border-green-600'
                      : 'border-gray-300'
                  "
                />
              </ValidationProvider>
            </div>
            <button
              :class="invalid ? 'bg-gray-300' : 'bg-green-600 hover:bg-green-700 text-white'"
              :disabled='loading||invalid'
              type='submit'
              class='
                mt-3
                w-full
                flex
                justify-center
                px-4
                py-2
                border border-transparent
                rounded-md
                shadow-sm
                text-sm
                font-medium
                text-white
                focus:outline-none
              '
            >
              {{ $t('sign-in') }}
              <vue-loaders v-if='loading' name='ball-beat' color='white' scale='0.5' />
            </button>
          </form>
        </ValidationObserver>
        <div v-else>
          <ValidationObserver ref='observer' v-slot='{ passes, invalid }'>
            <form @submit.prevent='passes(onSubmitRestForm)' class='space-y-3'>
              <div class='mt-2'>
                <ValidationProvider
                  v-slot='{ valid, errors }'
                  rules='required|phone'
                  name='phone'
                >
                  <input
                    name='phone'
                    type='text'
                    autocomplete='text'
                    v-model='rest_form.phone'
                    :placeholder="$t('phone')"
                    :state='errors[0] ? false : valid ? true : null'
                    class='
                    focus:outline-none
                    appearance-none
                    block
                    w-full
                    px-3
                    py-2
                    border border-gray-300
                    rounded-md
                    shadow-sm
                    placeholder-gray-400
                    sm:text-sm
                  '
                    :class="
                    errors.length > 0
                      ? 'border-red-400'
                      : rest_form.phone
                      ? 'border-green-600'
                      : 'border-gray-300'
                  "
                  />
                </ValidationProvider>
                <br>
                <ValidationProvider
                  v-slot='{ valid, errors }'
                  rules='required'
                  name='otp'
                >
                  <input
                    name='otp'
                    type='text'
                    autocomplete='text'
                    v-model='rest_form.otp'
                    :placeholder="$t('send_sms_code')"
                    :state='errors[0] ? false : valid ? true : null'
                    class='
                    focus:outline-none
                    appearance-none
                    block
                    w-full
                    px-3
                    py-2
                    border border-gray-300
                    rounded-md
                    shadow-sm
                    placeholder-gray-400
                    sm:text-sm
                  '
                    :class="
                    errors.length > 0
                      ? 'border-red-400'
                      : rest_form.otp
                      ? 'border-green-600'
                      : 'border-gray-300'
                  "
                  />
                </ValidationProvider>
                <br>
                <ValidationProvider
                  v-slot='{ valid, errors }'
                  rules='required'
                  name='password'
                >
                  <input
                    name='password'
                    type='text'
                    autocomplete='text'
                    v-model='rest_form.password'
                    :placeholder="$t('new_password')"
                    :state='errors[0] ? false : valid ? true : null'
                    class='
                    focus:outline-none
                    appearance-none
                    block
                    w-full
                    px-3
                    py-2
                    border border-gray-300
                    rounded-md
                    shadow-sm
                    placeholder-gray-400
                    sm:text-sm
                  '
                    :class="
                    errors.length > 0
                      ? 'border-red-400'
                      : rest.password
                      ? 'border-green-600'
                      : 'border-gray-300'
                  "
                  /> <br>
                </ValidationProvider>
              </div>
              <button
                :class="invalid ? 'bg-gray-300' : 'bg-green-600 hover:bg-green-700 text-white'"
                :disabled='loading||invalid'
                type='submit'
                class='
                mt-3
                w-full
                flex
                justify-center
                px-4
                py-2
                border border-transparent
                rounded-md
                shadow-sm
                text-sm
                font-medium
                text-white
                focus:outline-none
              '
              >
                {{ $t('sign-in') }}
                <vue-loaders v-if='loading' name='ball-beat' color='white' scale='0.5' />
              </button>
            </form>
          </ValidationObserver>
        </div>

        <div class='flex items-center justify-center mt-2'>
          <p class='text-gray-600 text-sm font-medium'>{{ $t('do-not-have-an-account') }}</p>
          <button class='ml-2 text-green-700 border-green-700 text-sm font-medium focus:outline-none'>
            <nuxt-link :to="localePath('/login')">
              {{ $t('login') }}
            </nuxt-link>
          </button>
<!--          <button class='ml-2 text-yellow-600 text-sm font-medium focus:outline-none'>-->
<!--            <nuxt-link :to="localePath('/register')">-->
<!--              {{ $t('register') }}-->
<!--            </nuxt-link>-->
<!--          </button>-->
<span v-if='!isPhoneSend && sec>0' class='ml-4 text-red-500'>{{minuts}}:{{sec > 9 ? sec : '0'+sec}}</span>
          <button class='ml-2 text-green-700 border-green-700 text-sm font-medium focus:outline-none' v-if='sec === 0' @click='sendPhone'>
            {{$t('resend')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import background from '../../assets/images/background.png'
import consultantWarningModal from '~/components/modals/consultant-warning'
const EMAILREG =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const MOBILEREG = /^([+]?[9]{2}[8][0-9]{2}[0-9]{7})$/
export default {
  name: 'Login',
  auth: false,
  props: {
    // eslint-disable-next-line vue/require-default-prop
    status: String
  },
  data() {
    return {
      isPhoneSend: true,
      image: background,
      loading: false,
      rest: {
        phone: ''
      },
      minuts: '00',
      sec: 59,
      rest_form: {
        phone: '',
        otp: '',
        password: ''
      }
    }
  },
  methods: {
    async sendPhone() {
      try {
        let _phone = this.rest.phone
        if (_phone.includes('+')) {
          _phone = _phone.split('+')[1]
        }
        const { data: { sms_service_data: { status } } } = await this.$axios.post('/users-permissions/resend_otp', { phone: _phone })
        if (status === 200) {
          this.loading = false
          this.rest_form.phone = _phone
          this.isPhoneSend = false
          this.$snotify.info(this.$t('phone_number_send_sms'))
          this.timeSetInterval()
        }
        return status
      } catch (err) {
          this.loading = false;
          this.rest.phone = ''
      }
    },


    async onSubmitPhone() {
      try {
        this.loading = true
        await this.sendPhone()
      } catch (err) {
      }
    },
    async onSubmitRestForm() {
      try {
        this.loading = true
        const { data } = await this.$axios.post('/users-permissions/recovery_password', { ...this.rest_form })
        if (data.user.id) {
          this.$snotify.success(this.$t('passwor_update'))
          this.$router.push({ path: this.localePath('/login') })
        }
      } catch (err) {
        this.loading = false
      }
    },
    timeSetInterval () {
      this.sec = 59;
      let sec = setInterval(() => {
        if (this.sec > 0) {
          this.sec--;
        } else if (this.sec === 0) {
          clearInterval(sec)
        }
      },1000)
    }
  },
  mounted() {


  }
}
</script>
